import React from "react";
import { AdminTherapistRole } from "../api/contracts";
import { getClinicianRolePillToken } from "../config/palette";
import {
  SingleSelectPillField,
  SingleSelectPillOption,
} from "./SingleSelectPillField";

const clinicianRoleOptions: readonly SingleSelectPillOption[] = [
  { id: "therapist", value: "therapist", label: "Therapist" },
  { id: "supervisor", value: "supervisor", label: "Supervisor" },
  { id: "admin", value: "admin", label: "Admin" },
];

export function ClinicianRoleSelect({
  id,
  value,
  onChange,
  ariaDescribedBy,
  disabled = false,
  invalid = false,
}: {
  id: string;
  value: AdminTherapistRole;
  onChange: (value: AdminTherapistRole) => void;
  ariaDescribedBy?: string;
  disabled?: boolean;
  invalid?: boolean;
}) {
  return (
    <SingleSelectPillField
      id={id}
      value={value}
      options={clinicianRoleOptions}
      onChange={(nextValue) => onChange(nextValue as AdminTherapistRole)}
      ariaLabel="Role"
      ariaDescribedBy={ariaDescribedBy}
      placeholder="Select a Role"
      searchPlaceholder="Search Roles"
      emptyMessage="No Roles found"
      resolveColor={(option) => getClinicianRolePillToken(option.value)}
      disabled={disabled}
      invalid={invalid}
    />
  );
}
